import { LayoutComponents } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";
import config from "appConfig";

import labels from "./labels";
import lightweightMale from "./lightweight-male";
import lightweightCrowd from "./lightweight-crowd";
import lightweightParty from "./lightweight-party";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 8,
        rows: 2,
        colSpan: {
          "0:0": 2,
          "0:2": 6,
          "1:0": 8,
        },
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "A generic representative of lightweight building structures. Its sound reduction index has been defined as an average of measurement results obtained for many real lightweight structures. The curve has been shifted to yield the minimum Rw required for each sound insulation class.",
                    formatter: "html",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                      fontSize: "12px",
                      lineHeight: "18px",
                      fontWeight: 400,
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  paddingTop: "5%",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {},
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/23/principle/lightweight.svg`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "layout",
              data: {
                type: "table",
                options: {
                  cols: 8,
                  rows: 4,
                  colsSize: [0.9, 1, 1, 1, 1, 1, 1, 1],
                  components: [labels, lightweightMale, lightweightCrowd, lightweightParty],
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
